import { Box } from "@chakra-ui/react";
import React from "react";
// import ClockLoader from "react-spinners/ClockLoader";
import HashLoader from "react-spinners/HashLoader";
// import PacmanLoader from "react-spinners/PacmanLoader";

import { COLORS } from "../../Helper/Colors";

const TableLoader = ({ isLoading, size, color, children, version = 7 }) => {
	return (
		<>
			{isLoading && (
				<Box position={"absolute"} top={"50%"} left={"50%"} zIndex={"100"}>
					{/* <ClockLoader size={size || 40} color={color || COLORS.brand} /> */}
					<HashLoader size={size || 30} color={color || COLORS.brand} />
					{/* <PacmanLoader size={size || 20} color={color || COLORS.brand} /> */}
				</Box>
			)}
			{!isLoading && version === 7 ? children : null}
		</>
	);
};

export default TableLoader;
